/* Imports */
import React from 'react'

/* Functional Component */
function Icon(props) {
  return (
    <props.icon className='mx-1' />
  )
}

/* Exports */
export default Icon